import { useFlags } from 'launchdarkly-react-client-sdk';

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export const FEATURE_FLAGS = {
  AB_TEST_SERIES_FEATURE_NAME_JULY21_IS_NEW:
    'ab-test-series-feature-name-july21-is-new',
  ADMIN_DASHBOARDS_ENABLE_TIME_FILTERING:
    'admin-dashboards-enable-time-filtering',
  ADMIN_DASHBOARDS_SHOW_FILTERS: 'admin-dashboards-show-filters',
  HIDE_SERIES_BANNER: 'hide-series-banner',
  NEW_COURSES_UI: 'new-courses-ui',
  PLUS_ONE: 'plus-one',
  RECOMMENDED_TOOLS_BANNER: 'recommended-tools-banner',
  SHOULD_SHOW_SEARCH_WEB: 'should-show-search-web',
  SHOW_ACTIVE_USER_TRACKING_CHANGE_NOTIFICATION:
    'show-active-user-tracking-change-notification',
  SHOW_ALTERNATIVE_START_SCREEN:
    'workplace-engagement-should-show-alternative-homescreen',
  SHOW_EXPLORE_WEB: 'show-explore-web',
  SHOW_INTEGRATIONS_TAB_WEB: 'show-integrations-tab-on-web',
  SHOW_PERSONALISED_RECOMMENDATIONS_WEB:
    'show-personalised-recommendations-web',
  SHOW_WORKPLACE_INSIGHTS_NAV_OPTION: 'show-workplace-insights-nav-option',
  SHOW_WELLBEING_SCORE_UPGRADE_BANNER: 'show-wellbeing-score-upgrade-banner',
  TEAM_GROWTH_NEW_SEND_INVITE_FLOW: 'team-growth-new-send-invite-flow',
  USE_REBRAND_THEME: 'use-rebrand-theme',
  SHOW_INVITE_LOVED_ONE_TAB_IN_MSTEAMS: 'show-invite-loved-one-tab-in-msteams',
  DATA_SCIENCE_API_READY: 'manager-engagement-data-science-api-ready',
  DATADOG_INIT_OPTIONS: 'datadog-init-options',
  DATADOG_START_SESSION_REPLAY_RECORDING:
    'datadog-start-session-replay-recording',
  SHOW_NOTIFICATION_PREFERENCE_CENTRE:
    'workplace-engagement-show-preference-centre',
  SHOW_EMAIL_NOTIFICATIONS: 'workplace-engagement-preference-center-v2',
  TEAMS_HOME_PAGE_EXPERIMENT: 'teams-home-page-experiment',
  NEW_START_ROUTE_ENABLED: 'enterprise-readiness-show-new-start-route',
  SUBDOMAINLESS_AUTH_ROUTES_ENABLED: 'subdomainless-auth-routes-enabled',
  NOVA_CONVERSATION_STYLES_ENABLED: 'nova-conversation-styles-enabled',
  NOVA_WEB_WELCOME_CONVERSATION: 'nova-web-welcome-conversation',
  NOVA_WEB_PENDING_MESSAGE_BADGE: 'nova-web-pending-message-badge',
  ENTERPRISE_READINESS_SHOW_MOBILE_DOWNLOAD_ON_FIRST_LOGIN:
    'enterprise-readiness-show-mobile-download-on-first-login',
  TALK_CAN_CANCEL_REQUEST: 'talk-cancel-event-requests',
  SHOW_EAP_ANALYTICS_DASHBOARD: 'show-eap-analytics-dashboard',
  MEMBERSHIP_ID_VERIFICATION_FLOW: 'activation-membership-id-verification-flow',
  HOMEPAGE_REDESIGN_ENABLED: 'homepage-redesign-enabled',
  HOMEPAGE_ONBOARDING_TODOLIST_ENABLED: 'activation-homepage-todo-list',
  PIPL_CONSENT_FLOW: 'activation-pipl-consent-flow',
  WELCOME_MODAL_ENABLED: 'activation-web-welcome-onboarding',
  SUPPORT_FINDER_TODOLIST_ITEM_ENABLED:
    'activation-homepage-support-finder-item',
  TALK_GENDER_AND_ETHNICITY: 'talk-gender-and-ethnicity',
} as const;

function useFeatureFlag<T = boolean>(flag: FeatureFlag): T {
  const allFlags = useFlags();

  return allFlags[flag];
}

export default useFeatureFlag;
